'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import ProfessionalNotFound from
  '@/app/(main)/(pages)/(institucional)/(index)/profissionais/[slug]/_components/professional-not-found.component';
import EmptyState from '@/app/(main)/_components/empty-state/empty-state';
import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import { getLogger } from '@/logger/logger';

export default function NotFoundState() {
  const pathname = usePathname();
  const isProfessionalRoute = pathname?.includes('/profissionais/');

  useEffect(() => {
    const logger = getLogger('NotFoundState');
    logger.warn('Not found', { pathname });
  });

  return (
    <>
      {isProfessionalRoute
        ? (
            <>
              <Breadcrumb
                list={[
                  {
                    label: 'Profissionais',
                    href: '/profissionais/',
                  },
                  {
                    label: '404',
                  },
                ]}
              />
              <ProfessionalNotFound />
            </>
          )
        : (
            <>
              <Breadcrumb
                list={[
                  {
                    label: 'Página não encontrada',
                    href: '/',
                  },
                ]}
              />
              <EmptyState
                title="Página não encontrada"
                description="A página que você está procurando não existe ou foi movida."
                button={{
                  label: 'Página inicial',
                  href: '/',
                }}
              />
            </>
          )}
    </>
  );
}
